import e, { useState as r, useEffect as n } from "react";
import t from "prop-types";
import { css as i, cx as o } from "@leafygreen-ui/emotion";
import { useIdAllocator as a } from "@leafygreen-ui/hooks";

function l() {
  return l = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var n = arguments[r];

      for (var t in n) {
        Object.prototype.hasOwnProperty.call(n, t) && (e[t] = n[t]);
      }
    }

    return e;
  }, l.apply(this, arguments);
}

function c(e, r) {
  if (null == e) return {};

  var n,
      t,
      i = function (e, r) {
    if (null == e) return {};
    var n,
        t,
        i = {},
        o = Object.keys(e);

    for (t = 0; t < o.length; t++) {
      n = o[t], r.indexOf(n) >= 0 || (i[n] = e[n]);
    }

    return i;
  }(e, r);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);

    for (t = 0; t < o.length; t++) {
      n = o[t], r.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (i[n] = e[n]);
    }
  }

  return i;
}

function u(e, r) {
  return r || (r = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(r)
    }
  }));
}

function f(e, r) {
  return function (e) {
    if (Array.isArray(e)) return e;
  }(e) || function (e, r) {
    var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
    if (null == n) return;
    var t,
        i,
        o = [],
        a = !0,
        l = !1;

    try {
      for (n = n.call(e); !(a = (t = n.next()).done) && (o.push(t.value), !r || o.length !== r); a = !0) {
        ;
      }
    } catch (e) {
      l = !0, i = e;
    } finally {
      try {
        a || null == n.return || n.return();
      } finally {
        if (l) throw i;
      }
    }

    return o;
  }(e, r) || function (e, r) {
    if (!e) return;
    if ("string" == typeof e) return s(e, r);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    "Object" === n && e.constructor && (n = e.constructor.name);
    if ("Map" === n || "Set" === n) return Array.from(e);
    if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return s(e, r);
  }(e, r) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function s(e, r) {
  (null == r || r > e.length) && (r = e.length);

  for (var n = 0, t = new Array(r); n < r; n++) {
    t[n] = e[n];
  }

  return t;
}

var p,
    d = ["children", "className"],
    m = i(p || (p = u(["\n  clip: rect(0, 0, 0, 0);\n  clip-path: inset(50%);\n  height: 1px;\n  width: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n"])));

function y(r) {
  var n = r.children,
      t = r.className,
      i = c(r, d);
  return e.createElement("div", l({}, i, {
    className: o(m, t)
  }), n);
}

y.displayName = "VisuallyHidden", y.propTypes = {
  children: t.string,
  className: t.string
};

var b,
    h = function h(e) {
  var r,
      n,
      t,
      i = a({
    prefix: "lgui-input",
    id: e
  }),
      o = a({
    prefix: "lgui-label"
  });
  return {
    labelProps: {
      id: o,
      htmlFor: i
    },
    inputProps: (t = o, (n = "aria-labelledby") in (r = {
      id: i
    }) ? Object.defineProperty(r, n, {
      value: t,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : r[n] = t, r)
  };
};

function v(e, r) {
  e["aria-label"] || e["aria-labelledby"] || console.error("For screen-reader accessibility, aria-label or aria-labelledby must be provided".concat(r ? " to ".concat(r) : "", "."));
}

function g(e) {
  return null != e && "string" == typeof e ? i(b || (b = u(["\n      @media (prefers-reduced-motion: reduce) {\n        ", "\n      }\n    "])), e) : "";
}

function w() {
  var e = f(r(!1), 2),
      t = e[0],
      i = e[1],
      o = function o(e) {
    i(e.matches);
  };

  return n(function () {
    if (window && window.matchMedia && "function" == typeof window.matchMedia) {
      var e = window.matchMedia("(prefers-reduced-motion: reduce)");
      return i(e.matches), e.addEventListener("change", o), function () {
        return e.removeEventListener("change", o);
      };
    }
  }, []), t;
}

export { y as VisuallyHidden, g as prefersReducedMotion, h as useAccessibleForm, w as usePrefersReducedMotion, v as validateAriaLabelProps };